export enum TechnicalErrorAttribute {
  RotationError = 517,
  IllegalTouch = 881,
  FootFault = 518,
  NetTouch = 519,
}
